<template>
  <!-- Botón de ayuda flotante abajo-derecha (chrome compartido). Siempre visible
       mientras hay contenido; al pulsarlo emite epc-click-help para que el host
       abra su diálogo de ayuda (atajos / herramientas / info de menús). -->
  <div class="epc-help">
    <b-tooltip :label="$t('help')" position="is-left">
      <div class="epc-help-btn" data-action="help" role="button" :aria-label="$t('help')"
        @click="$emit('epc-click-help')">
        <b-icon pack="fas" icon="question" size="is-small"></b-icon>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "WidgetHelp",
}
</script>

<style scoped>
.epc-help {
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 6;
}

.epc-help-btn {
  background-color: #ffffff;
  border: 1px solid #e3e3e8;
  border-radius: 50%;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  color: #343a40;
}

.epc-help-btn:hover {
  background-color: #f4f4f6;
  color: #3a6bc8;
}
</style>
